
import { GAME_TYPE, TYPE, canOnlyGo, cannotGo, canGo } from "./network/network_api";
import { REQUEST_TYPE } from "./network/net";
import Stream from "./frp/stream";

export default function(
    parent,
    bonusSettings
)
{
    const space = parent.child( "bonus" );
    
    parent.s( "state" )
        .filter( state => state.type == TYPE.BONUS_1 )
        .to( space.s( "bonus:showResult" ) );
    parent.s( "state" )
        .filter( state => state.type == TYPE.BONUS_2 )
        .to( parent.s( "superbonus:showResult" ) );
    
    parent.s( "bonus:selection" )
        .map( choice => ({
            type : REQUEST_TYPE.PROCEED_BONUS,
            bonusType : GAME_TYPE.BONUS_1,
            choice
        }) )
        .to( parent.s( "request" ) );
    parent.s( "superbonus:selection" )
        .map( choice => ({
            type : REQUEST_TYPE.PROCEED_BONUS,
            bonusType : GAME_TYPE.BONUS_2,
            choice
        }) )
        .to( parent.s( "request" ) );
    
    parent.s( "state" )
        .map( state => _.includes(
            [
                TYPE.BONUS_1,
                TYPE.BONUS_2,
                TYPE.BONUS_3
            ],
            state.type
        ) )
        .to( parent.s( "ui:isBonus" ) );
    
    //lose:
    parent.s( "bonus:displayComplete" )
        .with( parent.s( "state" ), ( _, state ) => state )
        .filter( state => canOnlyGo( TYPE.FINISH, state ) )
        .map( () => ({ type : REQUEST_TYPE.PROCEED }) )
        .to( parent.s( "request" ) );
    //switch to superbonus:
    parent.s( "bonus:displayComplete" )
        .with( parent.s( "state" ), ( _, state ) => state )
        .filter( state => canOnlyGo( TYPE.BONUS_2, state ) )
        .name( space, "proceed_to_superbonus" )
        .on( state => {
            state.server.scenarioData = [];
            parent.s( "superbonus:showResult" ).next( state );
        } );
    
    //superbonus lose:
    parent.s( "superbonus:displayComplete" )
        .with( parent.s( "state" ), ( _, state ) => state )
        .filter( state => canOnlyGo( TYPE.FINISH, state ) )
        .map( () => ({ type : REQUEST_TYPE.PROCEED }) )
        .to( parent.s( "request" ) );
    
    //when bonus is ready for keyboard events (needed because first bonus step appears without server interaction):
    Stream.merge(
        parent.s( "bonus:beginComplete" ),
        parent.s( "superbonus:beginComplete" ),
        parent.s( "bonus:displayComplete" ),
        parent.s( "superbonus:displayComplete" )
    )
    .map( () => true )
    .to( space.s( "ready" ) );
    parent.s( "state" )
        .map( () => false )
        .to( space.s( "ready" ) );
    
    //selections by keyboard:
    if ( ! bonusSettings ) return;
    const $keyboard = parent.s( "keyboard" );
    let bonusIndex = 0
    for ( const bs of bonusSettings )
    {
        ++ bonusIndex
        
        let leaf;
        let type;
        switch ( bs.gameType )
        {
            case GAME_TYPE.BONUS_1:
                leaf = parent.child( 'bonus' )
                type = TYPE.BONUS_1;
                break;
            case GAME_TYPE.BONUS_2:
                leaf = parent.child( 'superbonus' )
                type = TYPE.BONUS_2;
                break;
        }
        switch ( bs.type )
        {
            case TYPE.BONUS_1:
                leaf = parent.child( 'bonus' )
                break
            case TYPE.BONUS_2:
                leaf = parent.child( 'superbonus' )
                break
        }
        if ( bs.type !== undefined ) type = bs.type
        if ( ! leaf )
        {
            console.error( "Undefined bonus type." );
            continue;
        }
        
        const $tryChoice = space.s( "tryChoice_" + bonusIndex )
        const $choice = space.s( "choice_" + bonusIndex )
        $tryChoice
            .with(
                parent.s( "state" ),
                space.s( "ready" ),
                parent.s( "pending" ),
                ( s, state, ready, pending ) => ({ s, state, ready, pending })
            )
            .map( ({ s, state, ready, pending }) => {
                let r = s ? s : {}
                r.can =
                    canGo( type, state )
                    &&
                    (
                        ! bs.exclusive
                        ||
                        ( ! s || ! s.hasOwnProperty( "choice" ) )
                        ||
                        ( ! state.server.scenarioData || ! _.includes( state.server.scenarioData, s.choice ) )
                    )
                    &&
                    ready
                    &&
                    pending === undefined
                return r
            } )
            .to( $choice )
        
        if ( bs.keyboard != "custom" && bs.keyboard != "altered" )
        {
            $keyboard
                .with( parent.s( "state" ), ( k, state ) => ({ k, state }) )
                .map( ({ k, state }) => choiceMap( k, state, bs ) )
                .filter( s => s !== undefined )
                .map( s => ({ choice : s }) )
                .to( $tryChoice )
        }
        
        if ( bs.keyboard != "custom" )
        {
            $choice
                .filter( ({ can }) => can )
                .map( ({ choice }) => choice )
                .to( leaf.s( "selection" ) )
        }
    }
}

const F2    = 113;
const F3    = 114;
const F4    = 115;
const F5    = 116;
const F6    = 117;

/** Must return choice per key or undefined if key cannot be matched.*/
function choiceMap( key, state, bonusSettings )
{
    let choicesAmount = bonusSettings.to - bonusSettings.from + 1
    if ( bonusSettings.choices )
    {
        let i = 0
        if ( state.server.math && state.server.math.bonus1Wins ) i = state.server.math.bonus1Wins.length
        choicesAmount = bonusSettings.choices[ i ]
    }
    
    let map;
    switch ( choicesAmount )
    {
        case 2:
            map = bonusSettings.choices
                ?
                {
                    [ F2 ] : 0,
                    [ F3 ] : 1
                }
                :
                {
                    [ F2 ] : 0,
                    [ F6 ] : 1
                }
            break
            
        case 3:
            map = bonusSettings.choices
                ?
                {
                    [ F2 ] : 0,
                    [ F3 ] : 1,
                    [ F4 ] : 2
                }
                :
                {
                    [ F2 ] : 0,
                    [ F4 ] : 1,
                    [ F6 ] : 2
                }
            break
            
        case 4:
            map = {
                [ F2 ] : 0,
                [ F3 ] : 1,
                [ F4 ] : 2,
                [ F5 ] : 3
            }
            break
            
        case 5:
            map = {
                [ F2 ] : 0,
                [ F3 ] : 1,
                [ F4 ] : 2,
                [ F5 ] : 3,
                [ F6 ] : 4
            }
            break
    }
    if ( ! map )
    {
        //selection now can be dynamic (based on server-side value), so at times map cannot be deducted, but the whole logic is OK:
        //console.error( "Unexpected bonus choices spec." )
        return
    }
    return map[ key ]
}






// WEBPACK FOOTER //
// ./src/library/bonus.es6